import React from 'react';
import { links } from '../data/site';
import { BookingButton } from './BookingButton';
import { trackEvent } from '../utils/analytics';
export function Hero() {
  return <section id="top" className="bg-paper" data-id="element-60" data-mp="9ktchjcqjuvn">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10 pt-14 pb-20 md:pt-20 md:pb-24" data-id="element-61" data-mp="9lv00naxu9u9">
        <div className="max-w-3xl" data-id="element-62" data-mp="4mrteyfb7vk6">
          <p className="text-xs sm:text-[0.8125rem] uppercase tracking-[0.14em] font-medium text-forest" data-id="element-63" data-mp="4jm5vnmbx1qk">
            Fractional Transformation Executive
          </p>

          <h1 className="mt-5 font-serif text-[2.625rem] sm:text-6xl lg:text-[4.25rem] leading-[1.05] tracking-tight text-ink" data-id="element-64" data-mp="xbpawzbp5obv">
            Get important work moving.
          </h1>

          <p className="mt-6 max-w-2xl text-lg sm:text-xl leading-relaxed text-ink-soft" data-id="element-65" data-mp="nczvreb6qhzb">
            When strategy stalls, leadership shifts, or operations fall behind, I help you find the
            real constraint and lead the work to fix it.
          </p>

          <figure className="mt-7 flex items-center gap-4" data-id="element-66" data-mp="3j8iyr3vxcowt">
            <img src={links.portrait} alt="Black-and-white portrait of Craig Thomas smiling, wearing a dark sweater" className="w-14 h-14 sm:w-16 sm:h-16 shrink-0 rounded-full object-cover border border-rule" data-id="element-67" data-mp="3j9265qny7uwl" />
            <figcaption className="leading-snug" data-id="element-68" data-mp="3e8whmjcz6oiq">
              <span className="block text-[0.9375rem] font-medium text-forest" data-id="element-69" data-mp="3ebiripnc9g44">
                Former COO and President of Fully
              </span>
              <span className="block mt-0.5 text-sm text-ink-mute" data-id="element-70" data-mp="358zq89z7bbjz">
                Craig Thomas · Portland, Oregon
              </span>
            </figcaption>
          </figure>

          <div className="mt-9 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-7" data-id="element-71" data-mp="2viol4k3s6wbi">
            <BookingButton location="hero" className="w-full sm:w-auto" data-id="element-72" data-mp="2hj5clq725iyo" />
            <a href="#experience" onClick={() => trackEvent('see_the_work_click')} className="self-start sm:self-auto text-base text-ink-soft hover:text-forest border-b border-rule hover:border-forest pb-0.5 transition-colors duration-200" data-id="element-73" data-mp="2hl9td8q22cgd">
              See the work
            </a>
          </div>

          <p className="mt-4 text-sm text-ink-mute" data-id="element-74" data-mp="ibgor2sxlznx">Complimentary · 30 minutes</p>

          <p className="mt-8 pt-6 border-t border-rule max-w-2xl text-[0.9375rem] text-ink-soft" data-id="element-75" data-mp="ddnhs7jt11ml">
            2–6 month engagements · 10–20 hours per week
          </p>
        </div>
      </div>
    </section>;
}